// Untyped file as we can't otherwise import it inside vite.config.mts files (https://github.com/vitejs/vite/issues/5370)
/** @type {Record<string, string>} */
export const externalizedPackages = {
    // Linked to dependencies in package.json
    react: "React",
    "react-dom/client": "ReactDOM",
    "react/jsx-runtime": "JSXRuntime",
};
